var Tab = React.createClass({
  propTypes: {
    eventKey: React.PropTypes.any.isRequired,
    active: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      active: false
    }
  },
  tabClicked() {
    this.props.onClick(this.props.eventKey);
  },
  render() {
    return (
      <li className={classNames("tab-bar__item", {active: this.props.active})}>
        <a href="#" className="tab-bar__link" onClick={this.tabClicked}>{this.props.children}</a>
      </li>
    )
  }
})